<!-- 轮播项组件，替换van-swipe-item -->
<template>
  <div class="flex-none w-full relative">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
// SwipeItem 组件
</script>

<style scoped></style>
